import React from 'react'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
export default (props) => {
    if (!props.value || (props.prefix==="$" && Number(props.value)===0)||props.value==="") {
        return <></>
    } else {
        
        return (
          
            <Grid container direction="row" justify="flex-start" alignItems="baseline"  >
                <Grid item>
                    <Typography variant="subtitle2" display="block" component="div" >{props.title}</Typography>
                </Grid>
                <Grid item>
                    <Typography style={{marginLeft:2,color:props.color?props.color:"inherit"}} variant="body2" display="block" component="div" >{props.prefix}{props.value}</Typography>
                </Grid>
            </Grid>
        )
    }
}
